import MuiChip from '@material-ui/core/Chip';

export default MuiChip;
